import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  toast,
} from '@planuze/ui';
import { useSupportContent } from '../../content/sections/support.js';
import { useAssignTicket } from '../../hooks/use-tickets.js';
import { ticketErrorMessage } from './ticket-error.js';

interface Props {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly ticketId: string;
  readonly staffId: string;
}

/* "Atender" = atribui o ticket ao operador logado (staffId da sessão). */
export function AssignTicketModal({ open, onClose, ticketId, staffId }: Props) {
  const copy = useSupportContent();
  const assign = useAssignTicket(ticketId);
  const confirm = (): void => {
    assign.mutate(
      { assignedToStaffId: staffId },
      {
        onSuccess: () => {
          toast.success(copy.assignModal.successToast);
          onClose();
        },
        onError: (err) => {
          toast.error(ticketErrorMessage(err, copy.ticketErrors));
        },
      },
    );
  };
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next && !assign.isPending) onClose();
      }}
    >
      <DialogContent locked={assign.isPending}>
        <DialogHeader>
          <DialogTitle>{copy.assignModal.title}</DialogTitle>
          <DialogDescription>{copy.assignModal.description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} disabled={assign.isPending}>
            {copy.assignModal.cancel}
          </Button>
          <Button loading={assign.isPending} onClick={confirm}>
            {copy.assignModal.confirm}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
